import { Lightning, Utils } from "@lightningjs/sdk";
import { Card } from "./Card";
import { FOCUS_TRANSITION } from "./focus";
const asset = (name) => Utils.asset(`images/categories/${name}.svg`);
const icons = {
    replays: { x: 479.5, y: 23.8, w: 45, h: 54.3 },
    highlights: { x: 472, y: 31, w: 60, h: 40 },
    schedule: { x: 472, y: 21, w: 60, h: 60 },
};
export class CategoryCard extends Lightning.Component {
    static _template() {
        return {
            w: this.W,
            h: this.H,
            clipping: true,
            renderToTexture: true,
            shader: {
                type: Lightning.shaders.RoundedRectangle,
                radius: Card.BORDER_R,
            },
            Background: { w: this.W, h: this.H, rect: true, color: 0xff232b39 },
            Glow: {
                x: -6,
                y: -43,
                w: 556,
                h: 509,
                clipping: true,
                Large: {
                    x: -68.3,
                    y: -64.3,
                    w: 460.4,
                    h: 653.1,
                    texture: Lightning.Tools.getSvgTexture(asset("glow-large"), 461, 654),
                },
                Medium: {
                    x: -90.1,
                    y: 17.2,
                    w: 345.2,
                    h: 474.3,
                    texture: Lightning.Tools.getSvgTexture(asset("glow-medium"), 346, 475),
                },
                Small: {
                    x: -112,
                    y: 68.8,
                    w: 301.4,
                    h: 361.2,
                    texture: Lightning.Tools.getSvgTexture(asset("glow-small"), 302, 362),
                },
            },
            Shading: {
                x: 146,
                y: -217,
                w: 834,
                h: 834,
                texture: Lightning.Tools.getSvgTexture(asset("shading"), 834, 834),
            },
            Underline: {
                x: 422.1,
                y: 304,
                w: 149.8,
                h: 37,
                texture: Lightning.Tools.getSvgTexture(asset("underline"), 150, 37),
            },
            Title: {
                x: 29,
                y: 269,
                text: {
                    fontFace: "Insatiable Display",
                    fontStyle: "700",
                    fontSize: 60,
                    precision: 1,
                    w: 492,
                    h: 69,
                    lineHeight: 69,
                    offsetY: 57,
                    textAlign: "right",
                    textColor: 0xffffffff,
                    wordWrap: false,
                },
            },
            Icon: {},
            Border: {
                alpha: 0,
                color: Card.BORDER_COLOR,
                texture: Card.borderTexture(this.W, this.H),
            },
        };
    }
    static get width() {
        return this.W;
    }
    static get height() {
        return this.H;
    }
    static get marginRight() {
        return Card.marginRight;
    }
    set title(title) {
        this.tag("Title").patch({ text: { text: title } });
    }
    set icon(icon) {
        const { w, h } = icons[icon];
        this.tag("Icon").patch(Object.assign(Object.assign({}, icons[icon]), { texture: Lightning.Tools.getSvgTexture(asset(icon), w, h) }));
    }
    _focus() {
        this.tag("Border").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Border").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
}
CategoryCard.W = 550;
CategoryCard.H = 400;
export default CategoryCard;
//# sourceMappingURL=CategoryCard.js.map